module.exports = __webpack_public_path__ + "img/45.533d66e4.png";